import { AxiosError } from 'axios';
import apis from '../../src/services/api';
import { HttpStatusCode } from '../ui-constants/base/enum';
import { getAuthorizationToken, routeToLogin } from '../utils/commonUtils';
import errorStatus, { customErrorStatus } from '../utils/ErrorStatus';
import { post, postToDownloadDocument } from './api.service';
import { getCurrentSessionId } from './session.service';
import { threadId } from 'worker_threads';

export interface StartResearchResponse {
  session_id: string;
  status: string;
  clarifications?: string[];
}

type IUserData = {
  displayName: string;
  email: string;
  isExternal: boolean;
  profileImage: string;
  sid: { preferredName: string; rawIdToken?: string };
  rawIdToken?: string;
};

export async function startResearch(
  query: string,
  isDeepSearchSelected?: boolean,
  threadId?: string
): Promise<StartResearchResponse | any> {
  try {
    const response = await post(apis.deepResearchStartResearch, {
      query: query,
      deep_search: isDeepSearchSelected,
      threadId: threadId
    });
    return response;
  } catch (error: any) {
    if (!error?.response?.status) return customErrorStatus(error?.message);
    return errorStatus(error?.response?.status);
  }
}

export async function getStreamResearch(
  threadId: string,
  query: string,
  clarifications: string,
  answers: string,
  userData?: IUserData,
  isDeepResearchSelected?: boolean,
  controller?: AbortController
): Promise<any> {
  const computedBody: any = {
    threadId,
    query,
    deep_search: isDeepResearchSelected
  };
  if (clarifications) computedBody.clarifications = clarifications;
  if (answers) computedBody.answers = answers;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Session-Id': getCurrentSessionId() || '',
      'jwt-token': userData?.rawIdToken || '',
      'user-email': userData?.sid?.preferredName || '',
      'user-id': userData?.sid?.preferredName || '',
      Authorization: `Bearer ${await getAuthorizationToken()}`
    },
    body: JSON.stringify(computedBody),
    signal: controller && controller.signal ? controller.signal : null
  };
  return fetch(apis.deepResearchStreamingResearch, { ...requestOptions })
    .then((response) => {
      if (response.status === HttpStatusCode.Unauthorized) {
        routeToLogin();
      } else return response;
    })
    .catch((error) => {
      return handleFetchException(error);
    });
}

export const handleFetchException = (error: any) => {
  if (error?.response?.status === HttpStatusCode.Unauthorized) {
    routeToLogin();
  } else return errorStatus(error?.response?.status);
};

export function downloadDeepResearchChat(payload: any, responseType?: string): Promise<any> {
  const requestBody = {
    ...payload
  };
  let apiUrl = apis.deepResearchDownload;
  return postToDownloadDocument(apiUrl, requestBody, responseType)
    .then((response) => {
      return response;
    })
    .catch((error: AxiosError) => {
      const { response } = error;
      if (response?.status === 400) {
        return { response: [], status: 400 };
      } else if (response?.status === 404) {
        return { response: [], status: 404 };
      }
      return error;
    });
}
